import React from "react";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

interface Props {
  count?: number;
  variant?: boolean;
}

export const PropertyCardSkeleton: React.FC<Props> = ({
  count = 1,
  variant,
}) => {
  return (
    <>
      {Array.from({ length: count }).map((_, i) => (
        <div
          key={i}
          className={`rounded-xl flex border ${
            variant ? "flex-row" : "flex-col"
          } bg-white shadow-md overflow-hidden w-full animate-pulse`}
        >
          {/* Image Placeholder */}
          <div className="relative w-full h-[200px]">
            <Skeleton height="100%" width="100%" />
            <div className="absolute top-2 left-2 w-[70px] h-[25px]">
              <Skeleton />
            </div>
          </div>

          {/* Content */}
          <div className="p-4 flex flex-col gap-2">
            <Skeleton width="80%" height={20} />
            <Skeleton width="60%" height={16} />

            <div className="flex items-center gap-3 mt-2">
              <Skeleton circle width={20} height={20} />
              <Skeleton width="40%" height={14} />
            </div>

            <div className="flex items-center gap-3">
              <Skeleton circle width={20} height={20} />
              <Skeleton width="30%" height={14} />
            </div>

            <div className="flex items-center gap-3">
              <Skeleton circle width={20} height={20} />
              <Skeleton width="30%" height={14} />
            </div>

            <div className="mt-4">
              <Skeleton width="50%" height={24} />
              <Skeleton width="40%" height={16} />
            </div>
          </div>
        </div>
      ))}
    </>
  );
};
